import type { PermissionRequirement } from '~/utils/permissionRequirement'

/**
 * Accès à l'écran Suivi de projet : l'un des deux rôles de l'onglet (ADR 0010 du service
 * `apps/product-management`), le même test que `hasTabAccess` côté service. Les gestionnaires d'une
 * brique ne sont pas un droit Lucie : ils sont listés dans Notion.
 */
export const PRODUCT_MANAGEMENT_READ: PermissionRequirement = {
  any: [
    ['read', 'product-management.roles.contributor'],
    ['read', 'product-management.roles.administrator'],
  ],
}
